import { useIntl } from 'react-intl';
import { EuiFormLabel } from '@elastic/eui';
import { vehicleRegistrationDateISO8601 } from 'cache';
import { RangeFilter } from 'components/RangeFilter/RangeFilter';
import { getOptions, getRange } from 'utils';
import { useReactiveVar } from '@apollo/client';

import * as S from './FiltersSidebar.styles';

export const yearsOptions = getRange({ step: 1, from: new Date().getFullYear() + 1 - 50, size: 50 });
const getOptionsReversed = getOptions(yearsOptions).reverse();

export const VehicleRegistrationDateISO8601Filter = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const options = useReactiveVar(vehicleRegistrationDateISO8601);

  //TODO should be shared between packages
  const getValues = (o: { min: string; max: string }): { min?: string; max?: string } => {
    if (!o?.min && !o?.max) return { min: undefined, max: undefined };
    if (o?.min?.length > 4 || o?.max?.length > 4)
      return {
        min: String(new Date(o.min).getFullYear()),
        max: String(new Date(o.max).getFullYear()),
      };
    return o;
  };

  return (
    <S.SidebarFilterWrapper>
      <EuiFormLabel>{formatMessage({ id: 'filters.vehicleRegistrationDateISO8601.label' })}</EuiFormLabel>
      <RangeFilter
        values={getValues(options as { min: string; max: string }) as { min: string; max: string }}
        onChange={vehicleRegistrationDateISO8601}
        data={getOptionsReversed}
      />
    </S.SidebarFilterWrapper>
  );
};
